export default __webpack_public_path__ + "static/media/message.43dc6649.webp";